module.exports = __webpack_public_path__ + "img/invoice-de-female-wm-banner-sh.3a9f87af.png";